var $478a66e2828d03bc$exports = {};
const $478a66e2828d03bc$var$capturesMap = {
    'cases': "\u041A\u0435\u0439\u0441\u044B \u043D\u0430\u0448\u0438\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432\xa0\u2014\xa0\u043A\u0430\u043A \u0444\u0438\u0434\u0431\u0435\u043A \u0443\u043B\u0443\u0447\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B",
    'clients': "\u041D\u0430\u043C \u0434\u043E\u0432\u0435\u0440\u044F\u044E\u0442 90+ \u0432\u0435\u0434\u0443\u0449\u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u0432\xa0\u0420\u043E\u0441\u0441\u0438\u0438\xa0\u0438\xa0\u043C\u0438\u0440\u0435"
};
const $478a66e2828d03bc$var$capture = document.querySelector(`h1.capture`);
const $478a66e2828d03bc$var$cases = [
    ...document.querySelector('.content .cases').children
];
const $478a66e2828d03bc$var$filtersSelects = [
    ...document.querySelectorAll('.filtersWrapper .filter .select .currentValue')
];
const $478a66e2828d03bc$var$emptyBlock = document.querySelector('.empty');
const $478a66e2828d03bc$var$tabs = [
    ...document.querySelectorAll('.casesClients [data-tab]')
];
const $478a66e2828d03bc$var$hash = location.hash.slice(1);
const $478a66e2828d03bc$var$activeTab = !$478a66e2828d03bc$var$hash || $478a66e2828d03bc$var$hash === 'form-demo' ? 'cases' : $478a66e2828d03bc$var$hash;
const $478a66e2828d03bc$var$queryParams = new URLSearchParams(location.search);
const $478a66e2828d03bc$var$activePageNodes = [
    ...document.querySelectorAll(`[data-tab="${$478a66e2828d03bc$var$activeTab}"]`)
];
const $478a66e2828d03bc$var$allFilterOptionsList = [
    ...document.querySelectorAll('.selectList li')
];
const $478a66e2828d03bc$var$resetButton = document.querySelector('.resetButton');
const $478a66e2828d03bc$var$tags = [
    ...document.querySelectorAll('.tags .tag')
];
const $478a66e2828d03bc$var$YM_ID = 49633516;
const $478a66e2828d03bc$var$sectionName = window.location.href.includes('https://uxfeedback.ru') ? 'cases' : 'test_cases';
let $478a66e2828d03bc$var$openedFilter = null;
const $478a66e2828d03bc$var$filterTypes = [
    'format',
    'product',
    'sphere'
];
const $478a66e2828d03bc$var$filter = {
    format: $478a66e2828d03bc$var$queryParams.get('format')?.split(',') || [
        'all'
    ],
    product: $478a66e2828d03bc$var$queryParams.get('product')?.split(',') || [
        'all'
    ],
    sphere: $478a66e2828d03bc$var$queryParams.get('sphere')?.split(',') || [
        'all'
    ]
};
if ($478a66e2828d03bc$var$activePageNodes.length > 0) {
    $478a66e2828d03bc$var$capture.innerHTML = $478a66e2828d03bc$var$capturesMap[$478a66e2828d03bc$var$activeTab];
    [
        ...document.querySelectorAll(`.active[data-tab]`)
    ].map((node)=>{
        node.classList.remove('active');
    });
    $478a66e2828d03bc$var$activePageNodes.map((node)=>{
        node.classList.add('active');
    });
}
const $478a66e2828d03bc$var$filterCases = ()=>{
    const hiddenCases = $478a66e2828d03bc$var$cases.filter((item)=>!Object.values($478a66e2828d03bc$var$filter).every((filterValues)=>filterValues.some((value)=>item.dataset.types.includes(value))));
    $478a66e2828d03bc$var$cases.forEach((item)=>item.classList.remove('hide'));
    hiddenCases.forEach((item)=>item.classList.add('hide'));
    if ([
        ...new Set(Object.values($478a66e2828d03bc$var$filter).reduce((acc, filterValues)=>[
                ...acc,
                ...filterValues
            ], []))
    ].length > 1) $478a66e2828d03bc$var$resetButton.classList.add('active');
    else $478a66e2828d03bc$var$resetButton.classList.remove('active');
    if (hiddenCases.length === $478a66e2828d03bc$var$cases.length) $478a66e2828d03bc$var$emptyBlock.classList.add('show');
    else $478a66e2828d03bc$var$emptyBlock.classList.remove('show');
    const url = new URL(window.location.href);
    url.search = '';
    $478a66e2828d03bc$var$filterTypes.forEach((filterType)=>{
        url.searchParams.append(filterType, $478a66e2828d03bc$var$filter[filterType].join(','));
    });
    window.history.pushState({}, '', url);
};
const $478a66e2828d03bc$var$showFieldList = (element, text)=>{
    document.querySelector('.field.active').classList.remove('active');
    element.classList.add('active');
    document.querySelector('.field-filter').classList.remove('active');
    document.querySelector('.current-field span').textContent = text;
};
const $478a66e2828d03bc$var$changeFilterText = (filterType)=>{
    document.querySelector(`.filter.${filterType} .currentValue .value`).textContent = $478a66e2828d03bc$var$filter[filterType].map((value)=>document.querySelector(`[data-${filterType}=${value}] .name`).textContent).join(', ');
};
const $478a66e2828d03bc$var$selectAll = (filterType)=>{
    $478a66e2828d03bc$var$filter[filterType] = [
        'all'
    ];
    $478a66e2828d03bc$var$allFilterOptionsList.filter((item)=>item.classList.contains(filterType)).forEach((item)=>item.classList.remove('active'));
    document.querySelector(`[data-${filterType}=all]`).classList.add('active');
    $478a66e2828d03bc$var$changeFilterText(filterType);
    $478a66e2828d03bc$var$filterCases();
};
const $478a66e2828d03bc$var$getFilterType = (dataset)=>{
    if (dataset.format) return 'format';
    if (dataset.product) return 'product';
    return 'sphere';
};
const $478a66e2828d03bc$var$changeFilterValues = (filterType, currentTarget)=>{
    const { dataset: dataset } = currentTarget;
    return currentTarget.classList.contains('active') ? $478a66e2828d03bc$var$filter[filterType].filter((filterItem)=>filterItem !== dataset[filterType]) : [
        ...$478a66e2828d03bc$var$filter[filterType].filter((value)=>value !== 'all'),
        dataset[filterType]
    ];
};
const $478a66e2828d03bc$var$setFilter = ({ currentTarget: currentTarget })=>{
    const { dataset: dataset } = currentTarget;
    const filterType = $478a66e2828d03bc$var$getFilterType(dataset);
    const filterValues = $478a66e2828d03bc$var$changeFilterValues(filterType, currentTarget);
    if (filterValues.length === 0 || dataset[filterType] === 'all') {
        $478a66e2828d03bc$var$selectAll(filterType);
        window.ym?.($478a66e2828d03bc$var$YM_ID, 'reachGoal', 'filters_cases_click', {
            [$478a66e2828d03bc$var$sectionName]: {
                article_filters: $478a66e2828d03bc$var$filter
            }
        });
        return;
    }
    $478a66e2828d03bc$var$filter[filterType] = filterValues;
    currentTarget.classList.toggle('active');
    currentTarget.parentElement.querySelector(`[data-${filterType}=all]`).classList.remove('active');
    $478a66e2828d03bc$var$changeFilterText(filterType);
    $478a66e2828d03bc$var$filterCases();
    window.ym?.($478a66e2828d03bc$var$YM_ID, 'reachGoal', 'filters_cases_click', {
        [$478a66e2828d03bc$var$sectionName]: {
            article_filters: $478a66e2828d03bc$var$filter
        }
    });
};
const $478a66e2828d03bc$var$resetFilter = (type)=>()=>{
        $478a66e2828d03bc$var$filterTypes.forEach((filterType)=>{
            $478a66e2828d03bc$var$filter[filterType] = [
                'all'
            ];
            $478a66e2828d03bc$var$selectAll(filterType);
        });
        if (type) window.ym?.($478a66e2828d03bc$var$YM_ID, 'reachGoal', 'filters_cases_click', {
            [$478a66e2828d03bc$var$sectionName]: {
                article_filters: {
                    clear_all: type
                }
            }
        });
    };
const $478a66e2828d03bc$var$highlightFiltersItems = (filterType)=>{
    document.querySelector(`[data-${filterType}=all]`).classList.remove('active');
    $478a66e2828d03bc$var$allFilterOptionsList.filter((item)=>item.classList.contains(filterType) && $478a66e2828d03bc$var$filter[filterType].includes(item.dataset[filterType])).forEach((item)=>item.classList.add('active'));
};
$478a66e2828d03bc$var$tabs.map((tab)=>{
    tab.addEventListener('click', (e)=>{
        const { tab: tab } = e.target.dataset;
        $478a66e2828d03bc$var$capture.innerHTML = $478a66e2828d03bc$var$capturesMap[tab];
        [
            ...document.querySelectorAll(`.active[data-tab]:not([data-tab=${tab}])`)
        ].map((node)=>{
            node.classList.remove('active');
        });
        [
            ...document.querySelectorAll(`[data-tab=${tab}]`)
        ].map((node)=>{
            node.classList.add('active');
        });
    });
});
$478a66e2828d03bc$var$filtersSelects.map((filterElement)=>{
    filterElement.addEventListener('click', ({ currentTarget: currentTarget })=>{
        currentTarget.parentElement.classList.toggle('active');
        $478a66e2828d03bc$var$openedFilter = currentTarget.parentElement;
    });
});
document.addEventListener('click', ({ target: target })=>{
    if ($478a66e2828d03bc$var$openedFilter && !$478a66e2828d03bc$var$openedFilter.contains(target)) {
        $478a66e2828d03bc$var$openedFilter.classList.remove('active');
        $478a66e2828d03bc$var$openedFilter = null;
    }
}, {
    capture: true
});
$478a66e2828d03bc$var$emptyBlock.querySelector('.reset').addEventListener('click', $478a66e2828d03bc$var$resetFilter('page'));
$478a66e2828d03bc$var$resetButton.addEventListener('click', $478a66e2828d03bc$var$resetFilter('filters'));
$478a66e2828d03bc$var$allFilterOptionsList.forEach((optionElement)=>{
    optionElement.addEventListener('click', $478a66e2828d03bc$var$setFilter);
});
$478a66e2828d03bc$var$filterTypes.forEach((filterType)=>{
    $478a66e2828d03bc$var$highlightFiltersItems(filterType);
    $478a66e2828d03bc$var$changeFilterText(filterType);
    $478a66e2828d03bc$var$filterCases();
});
$478a66e2828d03bc$var$tags.forEach((tag)=>tag.addEventListener('click', ({ currentTarget: currentTarget })=>{
        const { dataset: dataset } = currentTarget;
        const filterType = $478a66e2828d03bc$var$getFilterType(dataset);
        $478a66e2828d03bc$var$resetFilter()();
        $478a66e2828d03bc$var$filter[filterType] = [
            dataset[filterType]
        ];
        $478a66e2828d03bc$var$highlightFiltersItems(filterType);
        $478a66e2828d03bc$var$changeFilterText(filterType);
        $478a66e2828d03bc$var$filterCases();
        document.querySelector('.filtersWrapper').scrollIntoView({
            block: 'end',
            behavior: 'smooth'
        });
    }));


//# sourceMappingURL=cases.e6e723f0.js.map
